import { OuterContentContainer } from "@shared/ui/OuterContentContainer";
import { Loader } from "@shared/ui/Loader";
import { AppPageHeader } from "@shared/ui/AppPageHeader";
import { useNotificationsState } from "../NotificationsContext";
import NotificationListContainer from "../components/NotificationList/NotificationListContainer";
import { useFetchUserCircles } from "@platform/hooks/useFetchUserCircles";

export function NotificationsPage() {
  const { isLoading, isRefetching } = useNotificationsState();

  // Load user circles data for chat visibility logic
  useFetchUserCircles();

  return (
    <OuterContentContainer className="flex flex-1" innerClassName="gap-8">
      <div className="flex flex-col gap-8 py-4">
        <AppPageHeader
          title="Notifications"
          description="Get caught up on the latest updates related to the program."
        />
      </div>
      <div className="w-full flex flex-col gap-6 pb-8">
        {isLoading && !isRefetching ? (
          <Loader />
        ) : (
          <NotificationListContainer isRefetching={isRefetching} />
        )}
      </div>
    </OuterContentContainer>
  );
}

export default NotificationsPage;
